import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';


import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';

import { tableComponent } from './table.component';

import { MainPipes } from '../pipes/main-pipes-module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng-lts/table';
import { DropdownModule } from 'primeng-lts/dropdown';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';

@NgModule({
  declarations: [
    tableComponent
  ],
  imports: [
    MainPipes,
    CommonModule,
    RouterModule,
    WaitLoadingModule,
    PanelModule,
    ScrollPanelModule,
    TranslateModule,
    FormsModule,
    DropdownModule,
    TableModule
  ],
  exports: [tableComponent]
})
export class TableComponentModule { }
